import { Link } from 'gatsby'
import styled from 'styled-components'
import { ThemeModes } from 'theme/theme'

export const StyledLink = styled(Link)`
    color: ${({ theme }) =>
        theme.mode === ThemeModes.HIGH_CONTRAST
            ? theme?.highContrast?.primary
            : theme.black};
    display: flex;
    align-items: center;
    gap: 20px;
    text-decoration: none;

    &:hover {
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST
                ? theme?.highContrast?.primary
                : theme.black} !important;
    }
`

export const UserInfo = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    cursor: pointer;
`
